@let errorMessage = errorMessage$();

<rt-dialog-header>
  <rt-heading variant="large-xx heading">{{
    'tlc.members.edit_member.account_tab.section.email.dialog.heading' | translate
  }}</rt-heading></rt-dialog-header
>
<rt-dialog-body layout layout-vertical>
  <div>
    {{ 'tlc.members.edit_member.account_tab.section.email.dialog.description' | translate }}
  </div>

  <form [formGroup]="form" padding-top>
    <rt-label>{{
      'tlc.members.edit_member.account_tab.section.email.dialog.label' | translate
    }}</rt-label>
    <rt-input
      [class.invalid]="!form.pristine && (form.invalid || errorMessage)"
      formControlName="email"
    />
    @if (errorMessage) {
      <span text-critical>{{ errorMessage }}</span>
    }
  </form>
</rt-dialog-body>
<rt-dialog-footer variant="white">
  <rt-button (click)="cancel()" variant="plain">{{ 'tlc.common.cancel' | translate }}</rt-button>
  <rt-button
    class="form-button"
    [disabled]="!form.dirty || form.invalid"
    (click)="submit()"
    variant="primary"
    >{{ 'tlc.members.edit_member.account_tab.section.email.dialog.button' | translate }}</rt-button
  >
</rt-dialog-footer>
